











import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class Name extends Vue {
  private paws: any = [];
  private del(index: any) {
    const d: any = this.paws;
    d.splice(index, 1);
    localStorage.setItem("xunzhengpaws", JSON.stringify(d));
    this.$forceUpdate();
    this.$emit("delPaw", d);
  }
  mounted() {
    if (localStorage.getItem("xunzhengpaws")) {
      this.paws = JSON.parse(localStorage.getItem("xunzhengpaws") || "");
    }
  }
}
